'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _editorStoreConnect = require('../components/editorStoreConnect');

var _editorStoreConnect2 = _interopRequireDefault(_editorStoreConnect);

var _editorActions = require('../editorActions');

var _editorStoreSelector = require('../reducers/editorStoreSelector');

var _milanoteReselect = require('../../../../utils/milanoteReselect/milanoteReselect');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Simply separates the store connection logic out of the TextEditor components as they are already very large.
 */

// Utils
var mapEditorDispatchToProps = function mapEditorDispatchToProps(dispatch) {
    return {
        editorStateChanged: function editorStateChanged(_ref) {
            var editorId = _ref.editorId,
                editorState = _ref.editorState;
            return dispatch((0, _editorActions.editorStateChanged)({ editorId: editorId, editorState: editorState }));
        }
    };
};

var getEditorStateSlice = function getEditorStateSlice() {
    return function (state, ownProps) {
        return {
            editorState: (0, _editorStoreSelector.getEditorState)(state),
            isEditing: ownProps.isEditing && (0, _editorStoreSelector.getEditorId)(state) === ownProps.editorId
        };
    };
};

var editorStateSelectorEqualityChecker = function editorStateSelectorEqualityChecker(nextStateSlice, prevStateSlice) {
    if (nextStateSlice.isEditing) {
        return prevStateSlice.isEditing && prevStateSlice.editorState === nextStateSlice.editorState;
    }

    return true;
};

var createCustomEditorStateSelector = (0, _milanoteReselect.createCustomEqualShallowSelector)(editorStateSelectorEqualityChecker);

var makeMapEditorStateToProps = function makeMapEditorStateToProps() {
    return createCustomEditorStateSelector(getEditorStateSlice(), function (_ref2) {
        var editorState = _ref2.editorState,
            isEditing = _ref2.isEditing;
        return {
            editorState: isEditing ? editorState : null
        };
    });
};

exports.default = (0, _editorStoreConnect2.default)(makeMapEditorStateToProps, mapEditorDispatchToProps);


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/store/components/textEditorStoreConnector.js
// module id = 1748
// module chunks = 0